<template>
    <v-card
        :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'"
        elevation="0"
        class="all-trade-tab rounded-0"
    >
        <v-tabs
            :background-color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'"
            v-model="model"
        >
            <v-tab class="ml-0" :href="`#tab-1`"> All Accounts </v-tab>
            <v-tab :href="`#tab-2`"> Bank Accounts </v-tab>
            <v-tab :href="`#tab-3`"> Crypto Addresses </v-tab>
           
            
            <v-tabs-items v-model="model">
                <v-tab-item :value="`tab-1`">
                    <AllAccountsTab></AllAccountsTab>
                </v-tab-item>
                <v-tab-item :value="`tab-2`">
                    <BankAccountsTab></BankAccountsTab>
                </v-tab-item>
                <v-tab-item :value="`tab-3`">
                   <CryptoAccountsTab></CryptoAccountsTab>
                </v-tab-item>
                
               
            </v-tabs-items>
        </v-tabs>
    </v-card>
</template>

<script>
import AllAccountsTab from "./AllAccountsTab.vue";
import BankAccountsTab from "./BankAccountsTab.vue";
import CryptoAccountsTab from "./CryptoAccountsTab.vue";


export default {
    components: {
        AllAccountsTab,
        BankAccountsTab,
        CryptoAccountsTab,
        
    },

    data() {
        return {
            model: "tab-1",
        };
    },
    mounted() {
        if (this.$route.query.tab) {
            this.model = `tab-${this.$route.query.tab}`;
        }
    },
    watch: {
        model: function (newModel) {
            const tab = newModel.split("-")[1];
            const currentQuery = { ...this.$route.query };
            if (tab) {
                currentQuery.tab = tab;
                this.$router.push({
                    path: this.$route.path,
                    query: currentQuery,
                });
            }
        },
        "$route.query.tab": function (newTab) {
            if (newTab) {
                this.model = `tab-${newTab}`;
            } else {
                this.$router.push({
                    path: this.$route.path,
                    query: { tab: null },
                });
            }
        },
    },
};
</script>
